/* M.O.S. theme JS */
(function () {
  // Mobile nav toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.step === 'up' ? 1 : -1;
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Product variant selection
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsEl = document.getElementById('ProductVariants');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = productForm.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var buyBtn = productForm.querySelector('[data-buy-button]');
    var selects = productForm.querySelectorAll('[data-option-select]');

    function currentVariant() {
      var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function update() {
      var v = currentVariant();
      if (!v) {
        if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = v.compare_at_price > v.price
          ? '<s>' + money(v.compare_at_price) + '</s>' + money(v.price)
          : money(v.price);
      }
      if (buyBtn) {
        buyBtn.disabled = !v.available;
        buyBtn.textContent = v.available ? buyBtn.dataset.labelAdd : buyBtn.dataset.labelSoldout;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    if (selects.length) update();
  }
})();
